<template>
  <a-upload
    name="file"
            ref="uploader"
            :action="uploadUrl"
            :multiple="true"
            list-type="picture-card"
            :customRequest="handleHttpRequest"
            :before-upload="beforeUpload"
            :remove = "removeFile"
            :file-list="fileList">
    <a-icon :type="loading ? 'loading' : 'plus'" />
  </a-upload>
</template>

<script>
import OssClient from '@/utils/OssClient';

export default {
  name: 'MultiUploader',
  props: {
    value: Array,
  },
  data() {
    return {
      loading: false,
      fileList: [],
      currentWidth: 0,
      currentHeight: 0,
      dialogImageUrl: '',
      headers: {
        token: localStorage.getItem('token'),
      },
      dialogVisible: false,
      uploadUrl: `${process.env.VUE_APP_BASE_URL}/upload`,
    };
  },
  methods: {
    getSize() {
      return {
        width: this.currentWidth,
        height: this.currentHeight,
      };
    },

    removeFile(e) {
      const values = this.value.filter(x => x !== e.url);
      this.$emit('input', [...values]);
    },
    random_string(len) {
      const len1 = len || 32;
      const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678';
      const maxPos = chars.length;
      let pwd = '';
      for (let i = 0; i < len1; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    async handleHttpRequest(option) {
      // 上传OSS
      const client = OssClient();
      // 随机命名
      const randomName = `${this.random_string(6)}_${new Date().getTime()}.${option.file.name
        .split('.')
        .pop()}`;

      try {
        // 分片上传文件
        const result = await client.put(randomName, option.file);
        if (result) {
          this.$emit('input', [...this.value, result.url]);
        }
      } catch (error) {
        this.$message.error('上传失败');
      }
    },
    getImgSize() {
      const img1 = this.value.length > 0 ? this.value[0] : null;
      if (img1 !== null) {
        const img = new Image();
        img.src = img1;
        if (img.complete) {
          this.currentWidth = img.width;
          this.currentHeight = img.height;
        }
      }
    },
    beforeUpload(file) {
      // todo need to check
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('You can only upload JPG file!');
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('Image must smaller than 2MB!');
      }
      return isJpgOrPng && isLt2M;
    },
  },
  watch: {
    value(val) {
      this.fileList = val.map(x => ({
        uid: x,
        name: x,
        status: 'done',
        url: x,
      }));
      this.getImgSize();
    },
  },
  created() {
    if (this.value) {
      this.fileList = this.value.map(x => ({
        uid: x,
        name: x,
        status: 'done',
        url: x,
      }));
      this.getImgSize();
    }
  },
};
</script>
